export class ClassBookTemplate {
    constructor(
      public id: string,
      public name: string,
      public iconLeft: string,
      public iconRight: string,
      public iconDefault: string,
      public order: number,
      public folder: any,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/settings/class-book-templates/shared/class-book-template.model.ts